/**
 * Platform-admin "peek into org" session (mirrors the backend ORG_PEEK token flow).
 * sessionStorage so a peek never outlives the tab; the token itself expires server-side in 60 min.
 */
const KEY = 'peekSession';

export function startPeek({ peekToken, orgId, orgName, expiresAt }) {
  sessionStorage.setItem(KEY, JSON.stringify({
    peekToken,
    orgId,
    orgName,
    // works for both ISO strings and epoch millis
    expiresAtMs: expiresAt ? new Date(expiresAt).getTime() : Date.now() + 60 * 60 * 1000,
  }));
  window.dispatchEvent(new Event('peek-changed'));
}

/** Active session, or null (expired sessions are cleared on read). */
export function peekSession() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const s = JSON.parse(raw);
    if (!s.peekToken || (s.expiresAtMs && Date.now() >= s.expiresAtMs)) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return s;
  } catch {
    sessionStorage.removeItem(KEY);
    return null;
  }
}

export function peekToken() {
  const s = peekSession();
  return s ? s.peekToken : null;
}

export function isPeeking() {
  return peekSession() !== null;
}

export function clearPeek() {
  sessionStorage.removeItem(KEY);
  window.dispatchEvent(new Event('peek-changed'));
}
